document.addEventListener('DOMContentLoaded', () => {

  // Base prices for Standard Vinyl (Matte, Glossy, etc.)
  const standardPriceMatrix = {
    "1": { base: 1.00 }, "2": { base: 1.05 }, "3": { base: 1.09 }, "4": { base: 1.15 }, "6": { base: 1.23 }, "9": { base: 1.33 }, "12": { base: 1.46 }, "16": { base: 1.60 }, "20": { base: 1.72 }, "25": { base: 1.89 }, "30": { base: 2.05 }, "36": { base: 2.22 }, "49": { base: 2.59 }, "64": { base: 3.00 }, "81": { base: 3.45 }, "100": { base: 3.92 }, "121": { base: 4.43 }, "144": { base: 4.96 }, "169": { base: 5.52 }, "196": { base: 6.13 }
  };

  // Base prices for Special Materials (Holographic, Glitter, Chrome, Clear)
  const specialPriceMatrix = {
    "1": { base: 1.15 }, "2": { base: 1.23 }, "3": { base: 1.28 }, "4": { base: 1.35 }, "6": { base: 1.44 }, "9": { base: 1.55 }, "12": { base: 1.70 }, "16": { base: 1.86 }, "20": { base: 2.00 }, "25": { base: 2.20 }, "30": { base: 2.38 }, "36": { base: 2.58 }, "49": { base: 3.00 }, "64": { base: 3.47 }, "81": { base: 3.99 }, "100": { base: 4.53 }, "121": { base: 5.12 }, "144": { base: 5.73 }, "169": { base: 6.37 }, "196": { base: 7.07 }
  };

  const discountMatrix = {
    "1": { "50": 0, "100": 43, "200": 67, "300": 75, "500": 81, "1000": 87, "2500": 93 }, "2": { "50": 0, "100": 42, "200": 64, "300": 75, "500": 79, "1000": 84, "2500": 90 }, "3": { "50": 0, "100": 40, "200": 62, "300": 70, "500": 76, "1000": 81, "2500": 88 }, "4": { "50": 0, "100": 40, "200": 62, "300": 70, "500": 76, "1000": 81, "2500": 88 }, "6": { "50": 0, "100": 40, "200": 62, "300": 70, "500": 76, "1000": 81, "2500": 88 }, "9": { "50": 0, "100": 35, "200": 54, "300": 61, "500": 68, "1000": 74, "2500": 81 }, "12": { "50": 0, "100": 35, "200": 54, "300": 61, "500": 68, "1000": 74, "2500": 81 }, "16": { "50": 0, "100": 35, "200": 54, "300": 61, "500": 68, "1000": 74, "2500": 81 }, "20": { "50": 0, "100": 30, "200": 47, "300": 54, "500": 61, "1000": 67, "2500": 73 }, "25": { "50": 0, "100": 30, "200": 47, "300": 54, "500": 61, "1000": 67, "2500": 73 }, "30": { "50": 0, "100": 30, "200": 47, "300": 54, "500": 61, "1000": 67, "2500": 73 }, "36": { "50": 0, "100": 25, "200": 40, "300": 47, "500": 53, "1000": 60, "2500": 67 }, "49": { "50": 0, "100": 25, "200": 40, "300": 47, "500": 53, "1000": 60, "2500": 67 }, "64": { "50": 0, "100": 25, "200": 40, "300": 47, "500": 53, "1000": 60, "2500": 67 }, "81": { "50": 0, "100": 20, "200": 34, "300": 41, "500": 47, "1000": 54, "2500": 61 }, "100": { "50": 0, "100": 20, "200": 34, "300": 41, "500": 47, "1000": 54, "2500": 61 }, "121": { "50": 0, "100": 20, "200": 34, "300": 41, "500": 47, "1000": 54, "2500": 61 }, "144": { "50": 0, "100": 18, "200": 30, "300": 36, "500": 43, "1000": 50, "2500": 52 }, "169": { "50": 0, "100": 18, "200": 30, "300": 36, "500": 43, "1000": 50, "2500": 52 }, "196": { "50": 0, "100": 18, "200": 30, "300": 36, "500": 43, "1000": 50, "2500": 52 }
  };

  // Both matrices share the same size keys, so we can just use standardPriceMatrix to generate tiers
  const sizeTiers = Object.keys(standardPriceMatrix).map(Number).sort((a, b) => a - b);
  const quantityTiers = [50, 100, 200, 300, 500, 1000, 2500];

  const formatMoney = (cents, format) => {
    const formatString = (format || window.shop_money_format || '${{amount}}');
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = formatString.match(placeholderRegex);
    if (!match || !match[1]) {
      const dollars = (cents / 100.0).toFixed(2);
      return `$${dollars}`;
    }
    function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number / 100.0).toFixed(precision);
      let parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };

  const initSideCart = () => {
    const sideCart = document.querySelector('#side-cart');
    if (!sideCart) return null;
    const cartButton = document.querySelector('#open-cart-btn');
    const closeCartButton = sideCart.querySelector('#close-cart-btn');
    const sideCartOverlay = document.querySelector('#side-cart-overlay');
    const openCart = () => { sideCart.classList.remove('translate-x-full'); sideCartOverlay.classList.remove('hidden'); };
    const closeCart = () => { sideCart.classList.add('translate-x-full'); sideCartOverlay.classList.add('hidden'); };
    const updateCart = () => {
      const sideCartItemsContainer = sideCart.querySelector('#side-cart-items');
      const sideCartSubtotal = sideCart.querySelector('#side-cart-subtotal');
      const cartCountBubble = document.querySelector('#cart-count-bubble');
      if (!sideCartItemsContainer) return;
      fetch('/cart.js').then(response => response.json()).then(data => {
        if (cartCountBubble) { cartCountBubble.textContent = data.items.length; cartCountBubble.classList.toggle('hidden', data.items.length === 0); }
        sideCartItemsContainer.innerHTML = '';
        if (data.items.length > 0) {
          data.items.forEach(item => {
            const itemEl = document.createElement('div');
            itemEl.className = 'flex gap-4 mb-4';
            
            const isCustomProduct = item.vendor === 'StickerGaffCustom';
            const productTitle = isCustomProduct ? item.properties._ProductTitle : item.product_title;
            const variantTitle = isCustomProduct ? item.properties.Finish : item.variant_title;
            const quantity = isCustomProduct ? item.properties.Quantity : item.quantity;

            let imageUrl = item.image; // Default to the product image
            let artworkFilename = null;

            if (isCustomProduct && item.properties.Artwork) {
              const artworkUrl = item.properties.Artwork;
              // Simple check for image extensions.
              if (artworkUrl.match(/\.(jpeg|jpg|gif|png|svg)$/i)) {
                imageUrl = artworkUrl;
              } else {
                // If it's not a standard image, we'll show the filename.
                artworkFilename = "." + artworkUrl.split('/').pop().split('.').pop() + "File";
              }
            }

            // --- START OF STICKER PACK CHANGES ---
            let stickerPackHtml = '';
            if (item.properties && item.properties['Sticker 1']) {
              stickerPackHtml = '<ul class="text-xs text-gray-400 list-disc list-inside mt-1">';
              for (let i = 1; i <= 5; i++) {
                if (item.properties[`Sticker ${i}`]) {
                  stickerPackHtml += `<li>${item.properties[`Sticker ${i}`]}</li>`;
                }
              }
              stickerPackHtml += '</ul>';
            }
            // --- END OF STICKER PACK CHANGES ---


            
            let propertiesHTML = '';
            if (item.properties) {
              const cutProperty = item.properties.Cut || item.properties._Cut;
              const sizeProperty = item.properties.Size || item.properties._Size;
              const customWidth = item.properties['Custom Width (in)'];
              const customHeight = item.properties['Custom Height (in)'];
              const instructions = item.properties['Additional Instructions'];
              const artworkProperty = item.properties.Artwork;

              if (cutProperty) { propertiesHTML += `<p class="text-sm text-gray-400">Cut: ${cutProperty}</p>`; }
              if (sizeProperty) { propertiesHTML += `<p class="text-sm text-gray-400">Size: ${sizeProperty}</p>`; }
              if (customWidth && customHeight) { propertiesHTML += `<p class="text-sm text-gray-400">W: ${customWidth}" H: ${customHeight}"</p>`; }
              if (instructions) { propertiesHTML += `<p class="text-sm text-gray-400">Instructions: ${instructions}</p>`;}
              if (artworkProperty) { propertiesHTML += `<p><a href="${artworkProperty}" class="text-accent underline" target="_blank">Artwork</a></p>`; }
            }

            let imageElement = '';
            if (artworkFilename) {
              imageElement = `<div class="w-24 h-24 bg-gray-700 rounded-md flex items-center justify-center text-center text-xs p-2 text-gray-400 break-all">${artworkFilename}</div>`;
            } else {
              imageElement = `<img src="${imageUrl}" alt="${item.title}" class="w-24 h-24 object-cover rounded-md">`;
            }

            itemEl.innerHTML = `
              
              ${imageElement}
              <div class="flex-grow relative">
                <button data-line-key="${item.key}" data-action="remove" class="absolute top-0 right-0 text-red-500 hover:text-red-700 p-1">
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                </button>
                <h4 class="font-bold pr-6">${productTitle}</h4>
                ${!item.properties['Sticker 1'] && variantTitle && variantTitle !== 'Default Title' ? `<p class="text-sm text-gray-400">${variantTitle}</p>` : ''}
                ${stickerPackHtml}
                ${propertiesHTML}
                <div class="flex justify-between items-center mt-2">
                    <p class="text-sm text-gray-400">Qty: ${quantity}</p>
                    <span class="font-bold">${formatMoney(item.line_price)}</span>
                </div>
              </div>`;
            sideCartItemsContainer.appendChild(itemEl);
          });
          sideCartSubtotal.textContent = formatMoney(data.total_price, window.shop_money_format);
        } else {
          sideCartItemsContainer.innerHTML = '<p class="text-center text-gray-400">Your cart is empty.</p>';
          sideCartSubtotal.textContent = formatMoney(0, window.shop_money_format);
        }
      });
    };
    const updateCartItemQuantity = (key, quantity) => { fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({ id: key, quantity: quantity }) }).then(() => updateCart()); };
    if (cartButton) cartButton.addEventListener('click', openCart);
    if (closeCartButton) closeCartButton.addEventListener('click', closeCart);
    if (sideCartOverlay) sideCartOverlay.addEventListener('click', closeCart);
    sideCart.addEventListener('click', (event) => {
      const targetButton = event.target.closest('button');
      if (!targetButton || !targetButton.dataset.action) return;
      if (targetButton.dataset.action === 'remove') {
        updateCartItemQuantity(targetButton.dataset.lineKey, 0); 
      }
    });
    return { updateCart, openCart };
  };

  const initProductPage = () => {
    const productForm = document.querySelector('.sticker-gaff-product-form');
    if (!productForm) return null;

    const priceDisplayEl = productForm.querySelector('#price-display');
    const perStickerPriceEl = productForm.querySelector('#per-sticker-price');
    const realQuantityInput = productForm.querySelector('input[name="properties[Quantity]"]');
    const quantityRadios = productForm.querySelectorAll('input[name="quantity_option"]');
    const customQuantityWrapper = productForm.querySelector('#custom-quantity-wrapper');
    const customQuantityInput = productForm.querySelector('#custom-quantity-input');
    const customSizeWrapper = productForm.querySelector('#custom-size-wrapper');
    const customWidthInput = productForm.querySelector('#custom-width');
    const customHeightInput = productForm.querySelector('#custom-height');
    const productTitleScript = productForm.querySelector('script[data-product-title]');
    const productTitle = productTitleScript ? JSON.parse(productTitleScript.textContent) : '';
    const fileUpload = productForm.querySelector('#file-upload'); 
    const filePreviewContainer = productForm.querySelector('#file-preview'); 
    const originalFilePreviewHTML = filePreviewContainer ? filePreviewContainer.innerHTML : '';
    const addToCartButton = productForm.querySelector('button[type="submit"]');
    const sizeValidationMessage = productForm.querySelector('#size-validation-message');
    const grossPriceDisplayEl = productForm.querySelector('#gross-price-display');

    let calculatedPrice = 0;
    
    const updateDiscountBubbles = (sqIn) => {
        const discountBubbles = productForm.querySelectorAll('.discount-bubble');
        if (sqIn <= 0) {
            discountBubbles.forEach(bubble => bubble.classList.add('hidden'));
            return;
        }

        const sizeTier = sizeTiers.slice().reverse().find(tier => tier <= sqIn) || sizeTiers[0];
        const discountData = discountMatrix[sizeTier];

        if (!discountData) return;

        discountBubbles.forEach(bubble => {
            const qty = bubble.dataset.qty;
            const discount = discountData[qty];

            if (discount && discount > 0) {
                bubble.textContent = `-${discount}%`;
                bubble.classList.remove('hidden');
            } else {
                bubble.classList.add('hidden');
            }
        });
    };
    
    const calculatePriceAndUpdateState = () => {
        const selectedSizeRadio = productForm.querySelector('input[name="properties[Size]"]:checked');
        
        // --- CHECK PRODUCT TITLE TO SELECT MATRIX ---
        // Determine if this is a special material product based on the title
        // (Holographic, Glitter, Chrome, Clear) vs Standard Vinyl
        const lowerTitle = productTitle.toLowerCase();
        const specialKeywords = ['holographic', 'glitter', 'chrome', 'clear'];
        
        const isSpecialProduct = specialKeywords.some(keyword => lowerTitle.includes(keyword));
        
        // Choose appropriate price matrix
        const currentPriceMatrix = isSpecialProduct ? specialPriceMatrix : standardPriceMatrix;
        // -----------------------------------------

        let sqIn = 0;
        let isSizeValid = true;

        if (selectedSizeRadio) {
            const selectedValue = selectedSizeRadio.value.toLowerCase();
            if (selectedValue === 'custom') {
                customSizeWrapper.classList.remove('hidden');
                const width = parseFloat(customWidthInput.value) || 0;
                const height = parseFloat(customHeightInput.value) || 0;
                const isInvalid = width > 14 || height > 14;
                
                if (sizeValidationMessage) {
                    sizeValidationMessage.classList.toggle('hidden', !isInvalid);
                }
                isSizeValid = !isInvalid;
                sqIn = width * height;

            } else {
                customSizeWrapper.classList.add('hidden');
                if (sizeValidationMessage) sizeValidationMessage.classList.add('hidden');
                switch (selectedValue) {
                    case 'small (2")': sqIn = 4; break;
                    case 'medium (3")': sqIn = 9; break;
                    case 'large (4")': sqIn = 16; break;
                    case 'extra large (5")': sqIn = 25; break;
                    default:
                        const dims = selectedSizeRadio.value.split('x').map(d => parseFloat(d.trim()));
                        if (dims.length === 2 && !isNaN(dims[0]) && !isNaN(dims[1])) {
                            sqIn = dims[0] * dims[1];
                        }
                        break;
                }
            }
        }
        
        updateDiscountBubbles(sqIn);

        if (sqIn <= 0 || !isSizeValid) {
            if (priceDisplayEl) priceDisplayEl.textContent = '--';
            if (perStickerPriceEl) perStickerPriceEl.textContent = '(Select a size)';
            if (grossPriceDisplayEl) grossPriceDisplayEl.classList.add('hidden');
            calculatedPrice = 0;
        } else {
            const sizeTier = sizeTiers.slice().reverse().find(tier => tier <= sqIn) || sizeTiers[0];
            const quantity = parseInt(realQuantityInput.value, 10);
            
            // Use the currently selected matrix for pricing lookup
            const priceData = currentPriceMatrix[sizeTier];
            
            const basePricePerSticker = priceData.base;
            const grossTotalPrice = basePricePerSticker * quantity;

            let discountPercent = 0;
            if (quantity >= 50) {
                const discountData = discountMatrix[sizeTier];
                const lowerQtyTier = quantityTiers.slice().reverse().find(tier => tier <= quantity);
                if(discountData && lowerQtyTier){
                    discountPercent = discountData[lowerQtyTier] || 0;
                }
            }
            
            const totalPrice = grossTotalPrice * (1 - (discountPercent / 100));
            const perStickerPrice = quantity > 0 ? totalPrice / quantity : 0;
            calculatedPrice = totalPrice;

            if (priceDisplayEl && perStickerPriceEl && !isNaN(totalPrice)) {
                priceDisplayEl.textContent = formatMoney(totalPrice * 100);
                perStickerPriceEl.textContent = `(${formatMoney(perStickerPrice * 100)} / sticker)`;
            }

            if (grossPriceDisplayEl) {
                if (discountPercent > 0) {
                    grossPriceDisplayEl.textContent = formatMoney(grossTotalPrice * 100);
                    grossPriceDisplayEl.classList.remove('hidden');
                } else {
                    grossPriceDisplayEl.classList.add('hidden');
                }
            }
        }

        if (addToCartButton) {
            addToCartButton.disabled = !isSizeValid;
            addToCartButton.textContent = isSizeValid ? 'Add to Cart' : 'Invalid Size';
        }
    };
    
    const clampValue = (input) => {
        if (parseFloat(input.value) > 14) {
            input.value = 14;
        }
        calculatePriceAndUpdateState();
    };

    const clampQty = (input) => {
        if (parseFloat(input.value) < 20) {
            input.value = 20;
        }
        if (realQuantityInput) {
            realQuantityInput.value = input.value;
        }
        calculatePriceAndUpdateState();
    };

    productForm.addEventListener('change', calculatePriceAndUpdateState);
    if (customWidthInput) customWidthInput.addEventListener('input', () => clampValue(customWidthInput));
    if (customHeightInput) customHeightInput.addEventListener('input', () => clampValue(customHeightInput));
    
    quantityRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            if (radio.value === 'custom') {
                customQuantityWrapper.classList.remove('hidden');
                realQuantityInput.value = customQuantityInput.value || '50';
            } else {
                customQuantityWrapper.classList.add('hidden');
                realQuantityInput.value = radio.value;
            }
            calculatePriceAndUpdateState();
        });
    });

    if (customQuantityInput) {
        customQuantityInput.addEventListener('input', () => {
            realQuantityInput.value = customQuantityInput.value;
            calculatePriceAndUpdateState();
        });
        customQuantityInput.addEventListener('change', () => clampQty(customQuantityInput));
    }

    if (fileUpload && filePreviewContainer) {
      fileUpload.addEventListener('change', function(event) {
        if (event.target.files.length > 0) {
          const file = event.target.files[0];
          const allowedImageTypes = ['image/svg+xml', 'image/jpeg', 'image/png'];
          const allowedOtherTypes = ['application/pdf', 'application/postscript', 'application/vnd.adobe.illustrator'];
          
          filePreviewContainer.innerHTML = ''; 

          if (allowedImageTypes.includes(file.type)) {
            const reader = new FileReader();
            reader.onload = function(e) {
              const img = document.createElement('img');
              img.src = e.target.result;
              img.style.maxHeight = '100%';
              img.style.maxWidth = '100%';
              img.style.objectFit = 'contain';
              filePreviewContainer.appendChild(img);
            }
            reader.readAsDataURL(file);
          } else if (allowedOtherTypes.includes(file.type)) {
            const fileNameEl = document.createElement('p');
            fileNameEl.textContent = file.name;
            fileNameEl.className = 'text-accent text-center break-all p-4';
            filePreviewContainer.appendChild(fileNameEl);
          } else {
            const errorEl = document.createElement('p');
            errorEl.textContent = 'Invalid file type';
            errorEl.className = 'text-red-500 text-center p-4';
            filePreviewContainer.appendChild(errorEl);
            fileUpload.value = '';
          }
        }
      });
    }
    
    const resetForm = () => { productForm.reset(); if (filePreviewContainer) filePreviewContainer.innerHTML = originalFilePreviewHTML; productForm.dispatchEvent(new Event('change', { bubbles: true })); };
    
    calculatePriceAndUpdateState();

    productForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const errorContainer = productForm.querySelector('#upload-error');
        if (errorContainer) errorContainer.textContent = '';
        if (!fileUpload || fileUpload.files.length === 0) {
            if (errorContainer) {
                errorContainer.textContent = 'Please upload your artwork before adding to cart.';
            } else {
                alert('Please upload your artwork before adding to cart.');
            }
            return;
        }

        const customPriceVariantId = productForm.querySelector('input[name="id"]').value;
        if (!customPriceVariantId) {
          alert('Error: Custom pricing product is not configured in the theme editor.');
          return;
        }
        
        const cartQuantity = Math.round(calculatedPrice * 100);
        if (cartQuantity <= 0) {
          alert("Please select a valid size and quantity.");
          return;
        }

        const formData = new FormData();
        formData.append('id', customPriceVariantId);
        formData.append('quantity', cartQuantity);

        const properties = {};
        properties._ProductTitle = productTitle;
        properties.Quantity = realQuantityInput.value;
        
        const selectedFinish = productForm.querySelector('input[name="properties[Finish]"]:checked');
        if (selectedFinish) {
          properties.Finish = selectedFinish.value;
        }

        const selectedSize = productForm.querySelector('input[name="properties[Size]"]:checked');
        if (selectedSize) {
           properties.Size = selectedSize.value;
        }

        if(selectedSize && selectedSize.value.toLowerCase() === 'custom'){
           properties['Custom Width (in)'] = customWidthInput.value;
           properties['Custom Height (in)'] = customHeightInput.value;
        }

        const selectedCut = productForm.querySelector('input[name="properties[Cut]"]:checked');
        if (selectedCut) {
           properties.Cut = selectedCut.value;
        }

        const instructionsInput = productForm.querySelector('#additional-instructions');
        if (instructionsInput && instructionsInput.value) {
            properties['Additional Instructions'] = instructionsInput.value;
        }

        for (const key in properties) {
          formData.append(`properties[${key}]`, properties[key]);
        }
        
        if (fileUpload.files.length > 0) {
          formData.append('properties[Artwork]', fileUpload.files[0]);
        }

        fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(response => response.json())
        .then(data => {
            if (data.status) { alert(data.description || 'Error adding to cart.'); return; }
            const cartInstance = initSideCart();
            if (cartInstance) {
              cartInstance.updateCart();
              cartInstance.openCart();
            }
            resetForm();
        })
        .catch(error => console.error('Error:', error));
    });

    return { form: productForm, reset: resetForm };
  };

  const cartInstance = initSideCart();
  
  if (document.querySelector('.sticker-gaff-product-form')) {
    initProductPage();
  }
  
  if (cartInstance) {
    cartInstance.updateCart();
  }

  window.stickerGaffCartInstance = cartInstance;

});